<!--  -->
<template>
  <div>
    <div>
      <div class="serch_box search_box">
        <div>
          <el-input v-model="query.employee_no" clearable style="width:200px;margin-right:10px" placeholder="请输入员工编号" />
          <!-- <el-input v-model="query.name" clearable style="width:200px;margin-right:10px" placeholder="请输入员工名字" /> -->
        </div>
        <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      :row-key="rowKey"
      max-height="550"
      border
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column
        type="selection"
        align="center"
        width="55"
        :reserve-selection="true"
        :selectable="selectable"
      /> -->
      <el-table-column
        prop="id"
        label="id"
        align="center"
        width="100"
      />
      <el-table-column
        prop="user_name"
        label="名字"
        align="center"
        width="150"
      />
      <el-table-column
        prop="employee_no"
        label="员工编号(企业名称)"
        align="center"
        width="350"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.employee_no!=''">
            {{ scope.row.employee_no }}（{{ scope.row.crop_name }}）
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="status_text"
        label="状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.status == 1" class="el-icon-warning defaultrse" />
          <i v-if="scope.row.status == 2" class="el-icon-success defaultr" />
          <i v-if="scope.row.status == 3" class="el-icon-error fasrw" />
          <i v-if="scope.row.status == 4" class="el-icon-error stopew" />
          {{ scope.row.status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="send_time"
        label="预计发送时间"
        align="center"
        width="200"
      /><el-table-column
        prop="real_send_time"
        label="实际发送时间"
        align="center"
        width="200"
      />
      <el-table-column
        prop="created_time"
        label="创建时间"
        align="center"
        width="200"
      />
      <el-table-column
        prop="notes"
        label="备注"
        align="center"
        width="400"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      :page-sizes="[10,20,50,100]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <!-- <el-button type="primary" size="mini" @click="unbind">解绑</el-button> -->
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { spWorkWechatOpStrategySendRecord } from '@/api/OperationStrategy.js'
// import { sprremoveBind } from '@/api/officialaccount.js'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        page_size: 10,
        operational_strategy_id: null,
        // ids: null,
        employee_no: null
        // name: null
        // keywords_group: null
      },
      selectlist: [],
      selectlistsend: [],
      namearr: [],
      grouparr: [],
      type: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    rowKey(row) {
      return row.id
    },
    selectable(row, index) {
      // eslint-disable-next-line eqeqeq
      return row.status != 2 // 通过某个值来进行判断，规定那一行的选择框被禁用
    },
    async list() {
      this.loading = true
      const data = await spWorkWechatOpStrategySendRecord(this.query)
      this.tableData = data.data.list
      this.total = data.data.count
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page = 1
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.employee_no = null
      // this.query.name = null
      // this.query.keywords_group = null
      this.list()
    },
    send(id, type) {
      this.query.operational_strategy_id = id
      this.type = type
      this.list()
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    }
    // unbind() {
    //   console.log(this.selectlist)
    //   if (this.selectlist.length === 0) {
    //     this.$message.error('请选择需要解绑的人员')
    //     return
    //   }
    //   // if (this.selectlist[0].group_selection === 3) {
    //   this.grouparr = []
    //   this.grouparr = this.selectlist.map((itemr, indexrs) => {
    //     console.log(itemr)
    //     return itemr.user_name
    //     // eslint-disable-next-line eqeqeq
    //     // return itemr.group_chats[0].group_chat_name
    //   })
    //   console.log(' this.grouparr :', this.grouparr)
    //   // } else {
    //   //   this.namearr = []
    //   //   this.namearr = this.selectlist.map((itemr, indexrs) => {
    //   //   // eslint-disable-next-line eqeqeq
    //   //     return itemr.name
    //   //   })
    //   // }
    //   const names = this.grouparr.slice(0, -1).join(', ') // 将最后一个元素之前的元素拼接成逗号分隔的字符串
    //   const lastPerson = this.grouparr[this.grouparr.length - 1] // 获取最后一个人的名字
    //   const confirmText = `确定解绑   ${names}    ${lastPerson}   吗?`

    //   this.$confirm(confirmText, '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.selectlistsend = []
    //     this.selectlistsend = this.selectlist.map((itemr, indexrs) => {
    //       // eslint-disable-next-line eqeqeq
    //       return itemr.id
    //     }).join(',')
    //     spWorkWechatOpStrategyStaff_unbind({
    //       ids: this.selectlistsend
    //     }).then((res) => {
    //       this.$emit('updata')
    //       this.$message({
    //         message: '解绑成功',
    //         type: 'success'
    //       })
    //     })
    //   }).catch(() => {

    //   })
    // }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.serch_box{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.sdwr{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.gecawe{
  display: inline-block;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
</style>
